import { Country, State, City } from 'country-state-city';
import { IOption } from 'types/common.types';

export const getCountries = (): IOption[] => {
  return Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));
};

export const getStates = (countryCode: string) => {
  if (!countryCode) return [];
  return State.getStatesOfCountry(countryCode.toUpperCase());
};

export const getCities = (countryCode: string, stateCode: string) => {
  if (!countryCode || !stateCode) return [];
  return City.getCitiesOfState(countryCode.toUpperCase(), stateCode.toUpperCase());
};
